export default {
  filterByStars: {
    id: 'reviews_rate_filter_title',
    defaultMessage: 'Filter by stars',
  },
  all: {
    id: 'reviews_rate_filter_all',
    defaultMessage: 'All',
  },
  five: {
    id: 'reviews_rate_filter_5',
    defaultMessage: '5 stars',
  },
  three: {
    id: 'reviews_rate_filter_more_than_3',
    defaultMessage: '3 stars',
  },
  one: {
    id: 'reviews_rate_filter_more_than_1',
    defaultMessage: '1 star',
  },
  ariaLabelAllRates: {
    id: 'reviews_rate_filter_a11y_all',
    defaultMessage: 'All ratings',
  },
  ariaLabelRangeRatesBetween: {
    id: 'reviews_rate_filter_a11y_range_between',
    defaultMessage: 'Between {min} and {max} stars',
  },
  filterReviewsParametersTitle: {
    id: 'reviews_parameter_selectors_title',
    defaultMessage: 'Only reviews',
  },
  filterReviewsCurrentSeller: {
    id: 'reviews_parameter_selectors_current_seller',
    defaultMessage: 'From current seller',
  },
  filterReviewsCurrentSellerTooltipTitle: {
    id: 'reviews_parameter_selectors_current_seller_tooltip_title',
    defaultMessage: 'What does this mean?',
  },
  filterReviewsCurrentSellerTooltipText: {
    id: 'reviews_parameter_selectors_current_seller_tooltip_text',
    defaultMessage:
      'Since our marketplace is ever-changing, the seller for this item can vary',
  },
  filterReviewsWithPictures: {
    id: 'reviews_parameter_selectors_with_pictures',
    defaultMessage: 'With customer pictures',
  },
  filterReviewsCurrentCountry: {
    id: 'reviews_parameter_selectors_current_country',
    defaultMessage: 'From {country}',
  },
  filterByGradePremium: {
    id: 'reviews_grade_filter_premium',
    defaultMessage: 'Premium',
  },
  filterByGradeFlawless: {
    id: 'reviews_grade_filter_excellent',
    defaultMessage: 'Excellent',
  },
  filterByGradeGood: {
    id: 'reviews_grade_filter_good',
    defaultMessage: 'Good',
  },
  filterByGradeFair: {
    id: 'reviews_grade_filter_fair',
    defaultMessage: 'Fair',
  },
  filtersTitle: {
    id: 'reviews_filters_title',
    defaultMessage: 'Filters',
  },
  mobileFiltersClose: {
    id: 'reviews_mobile_filters_close',
    defaultMessage: 'Close',
  },
  applyFilters: {
    id: 'reviews_mobile_filters_apply',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'reviews_mobile_filters_reset',
    defaultMessage: 'Reset filters',
  },
  reviewScore: {
    id: 'reviews_filters_review_score',
    defaultMessage: 'Review score',
  },
  deviceCondition: {
    id: 'reviews_grade_filter_device_condition_title',
    defaultMessage: 'Device condition',
  },
  togglesSelectorsTitle: {
    id: 'reviews_filters_toggles_selectors_title',
    defaultMessage: 'Show only reviews',
  },
  rangeMinAriaLabel: {
    id: 'reviews_filters_range_min_aria_label',
    defaultMessage: 'Minimum value',
  },
  rangeMaxAriaLabel: {
    id: 'reviews_filters_range_max_aria_label',
    defaultMessage: 'Maximum value',
  },
}
